<template>
    <div class="card mb-2">
        <div class="card-header"><h3>{{module}}</h3></div>
        <div class="card-body">
            <canvas :id="module" :graphType="graphType"></canvas>
        </div>
    </div>
   
</template>

<script>
    export default {
        name: "bar",
        props:{
                module:{
                    type:String
                },
                graphType:{
                    type:String
                },
            },
            watch: {
                '$props':{
                handler: function (val, oldVal) { 
                    
                    this.LoadChart(val.module);
                 
                },
                deep: true
                }
            },
        data(){
            return {
                moduleName:null,
            }
        },
        mounted() {
            this.LoadChart(this.module);
            
        },
        methods: {
            LoadChart(valid){
               
                let searchaArray = require(`@/views/modules/${this.module}/dashlets/Graph.js`);

                let ctx = document.getElementById(valid);
                   let genericChart = new Chart(ctx, {
                            type: this.graphType,
                            data: {
                                labels: searchaArray.default.label,
                                datasets: [{
                                    label: '# of Votes',
                                    data: searchaArray.default.data,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                            scales: {
                                y: {
                                    beginAtZero: true
                                }
                            }
                            }
                    });

                    genericChart.destroy();

                    genericChart = new Chart(ctx, {
                        type: this.graphType,
                        data: {
                                labels: searchaArray.default.label,
                                datasets: [{
                                    label: '# of Votes',
                                    data: searchaArray.default.data,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                            scales: {
                                y: {
                                    beginAtZero: true
                                }
                            }
                            }
                        });
            },
           
        },
    }
</script>
<style>
    canvas{height:320px}
</style>
